import { requireServiceAccessor } from 'src/packages/di';
import { PRIMARY_LANG } from 'src/packages/language/consts';

export function getLocale(): string {
  const i18n = requireServiceAccessor('i18');
  return i18n().i18n.language || PRIMARY_LANG;
}
